import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/lib/auth';
import { useMe, useTimeZoneSync } from '@/lib/me';
import { ReadyMark } from './logo';
import { ThemeToggle } from './theme-toggle';
import { Button } from './ui';

const navClass = ({ isActive }: { isActive: boolean }) =>
  `rounded-md px-3 py-1.5 ${isActive ? 'font-medium text-foreground' : 'text-muted-foreground hover:text-foreground'}`;

export function Layout() {
  const { user, signOut } = useAuth();
  const me = useMe();
  useTimeZoneSync();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return (
    <div className="flex min-h-dvh flex-col">
      <header className="border-b border-border">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4">
          <Link to={user ? '/home' : '/'} className="flex items-center gap-2 font-semibold">
            <ReadyMark className="size-6 text-primary" />
            <span>Nirvik Ready</span>
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            {user ? (
              <>
                <NavLink to="/home" className={navClass}>
                  Home
                </NavLink>
                {me.data?.isPlatformAdmin && (
                  <NavLink to="/admin" className={navClass}>
                    Admin
                  </NavLink>
                )}
                <NavLink to="/account" className={(s) => `hidden sm:inline ${navClass(s)}`}>
                  {user.email}
                </NavLink>
                <Button
                  variant="ghost"
                  onClick={async () => {
                    await signOut();
                    queryClient.clear();
                    navigate('/');
                  }}
                >
                  Sign out
                </Button>
              </>
            ) : (
              <Button onClick={() => navigate('/signin')}>Sign in</Button>
            )}
            <ThemeToggle />
          </nav>
        </div>
      </header>
      <main className="mx-auto w-full max-w-5xl flex-1 px-4 py-10">
        <Outlet />
      </main>
      <footer className="border-t border-border py-6 text-center text-xs text-muted-foreground">
        Nirvik Ready · a Nirvik AI Labs product
      </footer>
    </div>
  );
}
